<template>
  <div class="setupScroll" id="setupScroll">
    <div class="setupScroll_body" v-if="windowWidth>767">
      <img class="img1" src="../../../assets/images/serviceSupport/setup-bossint.png" alt="" />
      <span class="setupScroll_content">
        <span>
          <span class="arrows" :class="'_arrow' + index" v-for="(img, index) in arrowData" :key="index">
            <img :src="img.url" alt="" />
          </span>
        </span>
        <span class="step">
          <img src="../../../assets/images/serviceSupport/step1.png" alt="" />
          <span class="step_title step_title_bottom">可行性调研</span>
        </span>
        <span>
          <span class="arrows" :class="'_arrow' + index" v-for="(img, index) in arrowData" :key="index">
            <img :src="img.url" alt="" />
          </span>
        </span>
        <span class="step">
          <img src="../../../assets/images/serviceSupport/step2.png" alt="" />
          <span class="step_title step_title_top">业务咨询</span>
        </span>
        <span>
          <span class="arrows" :class="'_arrow' + index" v-for="(img, index) in arrowData" :key="index">
            <img :src="img.url" alt="" />
          </span>
        </span>
        <span class="step">
          <img src="../../../assets/images/serviceSupport/step3.png" alt="" />
          <span class="step_title step_title_bottom">系统配置</span>
        </span>
        <span>
          <span class="arrows" :class="'_arrow' + index" v-for="(img, index) in arrowData" :key="index">
            <img :src="img.url" alt="" />
          </span>
        </span>
        <span class="step">
          <img src="../../../assets/images/serviceSupport/step4.png" alt="" />
          <span class="step_title step_title_top">一体化实施</span>
        </span>
        <span>
          <span class="arrows" :class="'_arrow' + index" v-for="(img, index) in arrowData" :key="index">
            <img :src="img.url" alt="" />
          </span>
        </span>
      </span>
      <img class="img1" src="../../../assets/images/serviceSupport/setup-end.png" alt="" />
    </div>
    <div class="setupScroll_body_phone" v-else>
      <img class="img1" src="../../../assets/images/serviceSupport/setup-bossint.png" alt="" />
      <span class="setupScroll_content">
        <span class="arrows-list">
          <span class="arrows" :class="'_arrow' + index" v-for="(img, index) in arrowData" :key="index">
            <img :src="img.url" alt="" />
          </span>
        </span>
        <span class="step">
          <img src="../../../assets/images/serviceSupport/step1.png" alt="" />
          <span class="step_title step_title_bottom">可行性调研</span>
        </span>
        <span class="arrows-list">
          <span class="arrows" :class="'_arrow' + index" v-for="(img, index) in arrowData" :key="index">
            <img :src="img.url" alt="" />
          </span>
        </span>
        <span class="step">
          <img src="../../../assets/images/serviceSupport/step2.png" alt="" />
          <span class="step_title step_title_top">业务咨询</span>
        </span>
        <span class="arrows-list">
          <span class="arrows" :class="'_arrow' + index" v-for="(img, index) in arrowData" :key="index">
            <img :src="img.url" alt="" />
          </span>
        </span>
        <span class="step">
          <img src="../../../assets/images/serviceSupport/step3.png" alt="" />
          <span class="step_title step_title_bottom">系统配置</span>
        </span>
        <span class="arrows-list">
          <span class="arrows" :class="'_arrow' + index" v-for="(img, index) in arrowData" :key="index">
            <img :src="img.url" alt="" />
          </span>
        </span>
        <span class="step">
          <img src="../../../assets/images/serviceSupport/step4.png" alt="" />
          <span class="step_title step_title_top">一体化实施</span>
        </span>
        <span class="arrows-list">
          <span class="arrows" :class="'_arrow' + index" v-for="(img, index) in arrowData" :key="index">
            <img :src="img.url" alt="" />
          </span>
        </span>
      </span>
      <img class="img1" src="../../../assets/images/serviceSupport/setup-end.png" alt="" />
    </div>
  </div>
</template>
<style lang="scss">
.setupScroll{
  overflow: auto;
  overflow-y: hidden;
  margin-bottom: 20px;
  .setupScroll_body {
    width: 1300px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-wrap: nowrap;
    .img1{
      
    }
    .setupScroll_content {
      display: flex;
      flex-wrap: nowrap;
      line-height: 140px;
      .step {
        text-align: center;
        position: relative;
        margin: 0 15px;
        .step_title {
          display: block;
          width: 85px;
          text-align: center;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          font-family: "MiSans";
        }
        .step_title_bottom {
          top: 40%;
        }
        .step_title_top {
          top: -40%;
        }
        &:hover{
          cursor: pointer;
          color: rgb(3, 70, 172);
        }
      }
      .arrows {
        margin: 0 1px 0 0;
      }
    }
  }
  .setupScroll_body_phone {
    margin: 0 auto;
    height: 100px;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    .img1{
      height: 75px;
    }
    .setupScroll_content {
      display: flex;
      flex-wrap: nowrap;
      .step {
        text-align: center;
        position: relative;
        margin: 0 15px;
        img{
          height: 40px;
          width: 34px;
          max-width: 34px;
        }
        .step_title {
          font-size: 12px;
          display: block;
          width: 85px;
          text-align: center;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          font-family: "MiSans";
        }
        .step_title_bottom {
          
        }
        .step_title_top {
          top: -60%;
        }
        &:hover{
          cursor: pointer;
          color: rgb(3, 70, 172);
        }
      }
      .arrows-list{
        display: flex;
        .arrows {
          margin: 0 1px 0 0;
          img{
            height: 4px;
            width: 3px;
            max-width: 3px;
          }
        }
      }
    }
  }
}
</style>
<script>
export default {
  name: "SetupScroll",
  data() {
    return {
      scrollLeft:'',
      arrowData: [
        { url: require("../../../assets/images/serviceSupport/arrow-dark.png") },
        { url: require("../../../assets/images/serviceSupport/arrow-dark.png") },
        { url: require("../../../assets/images/serviceSupport/arrow-dark.png") },
        { url: require("../../../assets/images/serviceSupport/arrow-dark.png") },
        { url: require("../../../assets/images/serviceSupport/arrow-dark.png") },
        { url: require("../../../assets/images/serviceSupport/arrow-dark.png") },
        { url: require("../../../assets/images/serviceSupport/arrow-dark.png") },
        { url: require("../../../assets/images/serviceSupport/arrow-dark.png") },
        { url: require("../../../assets/images/serviceSupport/arrow-dark.png") },
        { url: require("../../../assets/images/serviceSupport/arrow-dark.png") },
        { url: require("../../../assets/images/serviceSupport/arrow-dark.png") },
        { url: require("../../../assets/images/serviceSupport/arrow-dark.png") },
        { url: require("../../../assets/images/serviceSupport/arrow-dark.png") },
        { url: require("../../../assets/images/serviceSupport/arrow-dark.png") },
        { url: require("../../../assets/images/serviceSupport/arrow-dark.png") },
      ],
      windowWidth: document.documentElement.clientWidth,
    }
  },
  mounted(){
    this.Scroll()
  },
  methods:{
    Scroll(){
      let flag = ''
      let downX = ''
      let scrollLeft = ''
      setupScroll.addEventListener("mousedown",function(e) {
        flag = true
        downX = e.clientX
        scrollLeft = this.scrollLeft
      })
      
      setupScroll.addEventListener("mousemove",function(e) {
        if (flag) {
          let moveX = e.clientX
          let scrollX = moveX - downX
          this.scrollLeft = scrollLeft - scrollX
        }
      })
      setupScroll.addEventListener("mouseup",function() {
        flag = false
      })
      setupScroll.addEventListener("mouseleave",function() {
        flag = false
      })
    },
  },
}
</script>
